import React, { forwardRef, useState, useImperativeHandle, useEffect } from 'react';
import { SearchIcon } from 'lucide-react';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../../ui/dialog";
import { Label } from "../../ui/label"
import { RadioGroup, RadioGroupItem } from "../../ui/radio-group";
import TagManager from "react-gtm-module";


function GranularityPicker({ currentGranularity, setGranularity }) {
    /* Granularity picker popup */
    const granularities = [
        // { label: "1s", value: 1 },
        // { label: "3s", value: 3 },
        // { label: "5s", value: 5 },
        // { label: "15s", value: 15 },
        { label: "1m", value: 60 },
        { label: "5m", value: 300 },
        { label: "15m", value: 900 },
        { label: "1h", value: 3600 },
        { label: "2h", value: 7200 },
        { label: "4h", value: 14400 },
        { label: "1d", value: 86400 },
        { label: "1w", value: 604800 }

    ]

    const handleListItemClick = (value) => {
        setGranularity(value);
    };

    const handleOpenChange = (isOpen) => {
        TagManager.dataLayer({
            dataLayer: {
                event: 'granularity_picker_dialog',
                action: isOpen ? 'open' : 'close',
                label: currentGranularity.label
            },
        });
    };

    return <>
        <Dialog onOpenChange={handleOpenChange}>
            <DialogTrigger>
                <div
                    className="flex items-center space-x-2 focus:ring-2 focus:ring-offset-2 focus:ring-white rounded-md"
                >
                    <SearchIcon size={20} />
                    <span>{currentGranularity.label}</span>
                </div>
            </DialogTrigger>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Choose the granularity</DialogTitle>
                </DialogHeader>
                <RadioGroup defaultValue="option-one">
                    {granularities.map((granularity) => (
                        <div key={granularity.value} className="flex items-center space-x-2">
                            <RadioGroupItem onClick={() => handleListItemClick(granularity)} value={granularity.value} id={granularity.value} checked={granularity.value == currentGranularity.value} />
                            <Label htmlFor={granularity.value}>{granularity.label}</Label>
                        </div>
                    ))}
                </RadioGroup>

            </DialogContent>
        </Dialog>
    </>
}

export default GranularityPicker;